/*==================== 
Open Link in New Tab
==================== */

function openInNewTab (url) {
    window.open(url, "_blank", "noreferrer");
};

export default openInNewTab